
import HeartEdit from "../../../assets/filled/HeartEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HeartEditIcon({ className, dataTestid = "HeartEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HeartEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
